var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarth = function SvgEarth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M21.5 4.5c0 1.167-1.735 1.5-3 1.5C13.283 6 7.795 9.48 7.08 14.004 6.992 14.549 6.552 15 6 15H3m1 5.5c.786.262 2.126 1.285 3.44 1.517.57.101 1.153.464 1.299 1.023.303 1.16.548 1.992-.239 3.96m8.725-1.707c-1 0-5-2.2-5-9 0-5.5 3.5-7 8.5-7 3 0 5 1.5 5 5s-3.5 2.707-5 4.207 0 6.793-3.5 6.793ZM29 16c0 7.18-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3s13 5.82 13 13Z"
  })));
};
export default SvgEarth;